import { useTranslations } from 'next-intl';

export function useResolution() {
  const t = useTranslations();

  const resolutionMap = {
    '512': t('create.createForm.settings.model.optionSpeed.text'),
    '720p': '720p',
    '768': t('create.createForm.settings.model.optionStandard.text'),
    '1080p': '1080p',
    '2k': '2k',
    '4k': '4k',
  };

  return { resolutionMap };
}
